import React from "react";
import { LineOfBusiness } from "../../../../interface/line-of-business.interface";
import { Executive } from "../../../../interface/executive.interface";

interface ExecutiveDataProps {
    executive: Executive;
    linesOfBusiness: LineOfBusiness[];
}

export const ExecutiveData: React.FC<ExecutiveDataProps> = ({ executive, linesOfBusiness }) => {
    const { fullName, email, phone, idLineOfBusiness } = executive;
    const lineOfBusinessName = linesOfBusiness.find(
        lineOfBusiness => lineOfBusiness.cdRamo === idLineOfBusiness
    )?.nmRamo;

    return (
        <div className="d-flex flex-column gap-3">
            <div className="d-flex flex-column">
                <span className="text-neutral-900 fw-semibold">{fullName}</span>
                <a href={`mailto:${email}`} className="text-neutral-700 text-decoration-underline">
                    {email}
                </a>
            </div>
            <div className="d-flex gap-4">
                <div className="d-flex flex-column">
                    <span className="text-neutral-700">Teléfono:</span>
                    <a href={`tel:${phone}`} className="text-neutral-900 fw-semibold text-decoration-underline">
                        {phone}
                    </a>
                </div>
                <div className="d-flex flex-column">
                    <span className="text-neutral-700">Ramo:</span>
                    <span className="text-neutral-900 fw-semibold">{lineOfBusinessName ?? ""}</span>
                </div>
            </div>
        </div>
    );
};
